const sharedTestIDs = {
  sharedOptaviaLogo: 'shared-optavia-logo',
  sharedPopover: 'shared-popover',
  sharedScreenTitle: 'shared-screen-title',
  sharedMessageBannerView: 'shared-message-banner-view',
  sharedMessageBanner: 'shared-message-banner',
  sharedTimestamp: 'shared-timestamp',
  sharedLoadingIndicator: 'shared-loading-indicator',
  headingTitle: 'heading-title',
  datePicker: 'date-picker',
  newIndicatorView: 'new-tag-view',
  newIndicator: 'new-tag',
  radioButtonLabel: 'radio-button-label',
  radioButton: 'radio-button',
  radioButtonGroup: 'radio-button-group',
  radioButtonGroupTitle: 'radio-button-group-title',
  daysLeft: 'days-left-label',
  view: 'view',
  chatButton: 'chat-button',
  searchButton: 'search-button',
};

export default sharedTestIDs;
